import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked, ViewChild } from '@angular/core';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { EliminarEntidadComponent } from '../../../helpers/components/deleteEntity/deleteEntity.component';
import { Channel } from 'app/infrastructure/model/interfaces/channel.interface';
import { SxContextService } from 'app/infrastructure/services/sxContext.service';

@Component({
  selector: 'sx-home-channel',
  templateUrl: './home.channel.component.html',
  styleUrls: ['../../configuracion/subscription/nuevo.subscription.component.css']
})
export class HomeChannelComponent implements OnInit, AfterViewChecked {

  @ViewChild(EliminarEntidadComponent) eliminarEntidad: EliminarEntidadComponent;

  @Input('channel') channel: Channel;
  @Input('codOrganization') codOrganization: String;
  @Input('codSubscription') codSubscription: String;
  @Input('codChannel') codChannel: String;
  @Input('esNuevo') esNuevo: boolean;
  @Input('checkeandCodigo') checkeandCodigo: boolean;
  @Input('errorCodigo') errorCodigo: string;
  @Input('completitud') completitud: number;

  @Output('descripcionEditada') descripcionEditada: EventEmitter<string> = new EventEmitter();
  @Output('crearChannel') crearChannel: EventEmitter<string> = new EventEmitter();

  constructor(private router: Router, private route: ActivatedRoute,
    private contextService: SxContextService) { }

  ngOnInit() { }

  ngAfterViewChecked() {
    if (this.eliminarEntidad) {
      this.eliminarEntidad.eliminado.subscribe(eliminado => this.onDelete(eliminado));
    }
  }

  editarDescripcion(descripcion) {
    this.descripcionEditada.emit(descripcion);
  }

  confirmarNegocio() {
    this.crearChannel.emit();
  }

  agregarProducto() {
    this.router.navigate(['../products/nuevo'], { relativeTo: this.route });
  }

  verDetalleProducto(codProducto) {
    this.router.navigate(['../', codProducto], { relativeTo: this.route });
  }

  onDelete(param) {
    this.contextService.unloadMemory();
    this.router.navigate(['../../../'], { relativeTo: this.route });
  }

  configurar() {
    this.router.navigate(['../confNegocio'], { relativeTo: this.route });
  }

  publishPortal() {
    this.router.navigate(['../confNegocio/sponsor'], { relativeTo: this.route });
  }

  externalApi() {
    this.router.navigate(['../authorizationConfiguration'], { relativeTo: this.route });
  }

  volver() {
    if (this.channel.channelCode !== '') {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/detalle/home.channel.component.ts